module.exports = __webpack_public_path__ + "static/media/Icon material-play-arrow.9805b4e5.svg";